import React, { useState } from 'react';
import * as S from './styles';
import { useAuth } from '../../contexts/AuthContext';
import { 
  FaFileAlt, FaCogs, FaCalendarAlt, FaChartLine, FaEnvelope,
  FaBuilding, FaIndustry, FaClock, FaHourglassHalf, FaLightbulb,
  FaRocket, FaSearchDollar, FaSyncAlt, FaBalanceScale, FaFileInvoiceDollar,
  FaCalendarCheck, FaTasks, FaLayerGroup, FaDollarSign, FaBullseye,
  FaCheckCircle, FaClipboardList, FaSearch, FaChartBar, FaCheckCircle as FaCheck,
  FaHandHoldingUsd, FaCalculator, FaBolt, FaPhone, FaWhatsapp, FaHandshake
} from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';

const ReformaSYL = () => {
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Verificar se o usuário tem permissão para acessar esta página
  if (!user || user.email !== 'contabilidade@syl.com.br') {
    return (
      <S.Container>
        <S.AccessDeniedContainer>
          <S.AccessDeniedIcon>
            <FaCheckCircle />
          </S.AccessDeniedIcon>
          <S.AccessDeniedTitle>Acesso Restrito</S.AccessDeniedTitle>
          <S.AccessDeniedText>
            Esta página é exclusiva para o usuário autorizado.
          </S.AccessDeniedText>
          <S.AccessDeniedEmail>
            Usuário atual: {user?.email || 'Não autenticado'}
          </S.AccessDeniedEmail>
        </S.AccessDeniedContainer>
      </S.Container>
    );
  }

  return (
    <S.Container>
      {/* Navbar */}
      <S.Navbar>
        <S.NavbarContainer>
          <S.NavbarBrand href="#">
            <S.NavbarBrandIcon>FH</S.NavbarBrandIcon>
            <S.NavbarBrandText>Souza Advogados</S.NavbarBrandText>
          </S.NavbarBrand>

          <S.NavbarToggle onClick={toggleMobileMenu} $active={mobileMenuOpen}>
            <span></span>
            <span></span>
            <span></span>
          </S.NavbarToggle>

          <S.NavbarNav $active={mobileMenuOpen}>
            <li>
              <S.NavLink href="#resumo" onClick={closeMobileMenu}>
                <FaFileAlt /> Resumo Executivo
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#metodologia" onClick={closeMobileMenu}>
                <FaCogs /> Metodologia
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#cronograma" onClick={closeMobileMenu}>
                <FaCalendarAlt /> Cronograma
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#investimento" onClick={closeMobileMenu}>
                <FaChartLine /> Investimento
              </S.NavLink>
            </li>
            <li>
              <S.NavCTA href="#contato" onClick={closeMobileMenu}>
                <FaEnvelope /> Agendar Reunião
              </S.NavCTA>
            </li>
          </S.NavbarNav>
        </S.NavbarContainer>
      </S.Navbar>

      <S.NavbarOverlay $active={mobileMenuOpen} onClick={closeMobileMenu} />

      {/* Hero Section */}
      <S.HeroSection>
        <S.HeroContainer>
          <S.HeroContent>
            <S.HeroBadge>
              <S.Pulse />
              Proposta Comercial 2025
            </S.HeroBadge>

            <S.HeroTitle>
              Implementação Completa da
              <S.Highlight> Reforma Tributária</S.Highlight>
            </S.HeroTitle>

            <S.HeroSubtitle>
              Metodologia exclusiva em 5 blocos estratégicos para transição segura
              e otimizada ao novo sistema tributário
            </S.HeroSubtitle>

            {/* Client Info Card */}
            <S.ClientInfoCard>
              <S.ClientInfoHeader />
              <S.ClientInfoContent>
                <S.ClientInfoTitle>
                  <FaBuilding />
                  Informações do Projeto
                </S.ClientInfoTitle>
                <S.ClientInfoGrid>
                  <S.InfoItem>
                    <S.InfoLabel>Cliente</S.InfoLabel>
                    <S.InfoValue>
                      <FaIndustry />
                      SYL - Grupo Empresarial
                    </S.InfoValue>
                  </S.InfoItem>
                  <S.InfoItem>
                    <S.InfoLabel>Prazo Total</S.InfoLabel>
                    <S.InfoValue>
                      <FaClock />
                      16 semanas (4 meses)
                    </S.InfoValue>
                  </S.InfoItem>
                  <S.InfoItem>
                    <S.InfoLabel>Total de Horas</S.InfoLabel>
                    <S.InfoValue>
                      <FaHourglassHalf />
                      250 horas
                    </S.InfoValue>
                  </S.InfoItem>
                  <S.InfoItem>
                    <S.InfoLabel>Início da Vigência</S.InfoLabel>
                    <S.InfoValue>
                      <FaCalendarAlt />
                      Janeiro 2026
                    </S.InfoValue>
                  </S.InfoItem>
                </S.ClientInfoGrid>
              </S.ClientInfoContent>
            </S.ClientInfoCard>
          </S.HeroContent>
        </S.HeroContainer>
      </S.HeroSection>

      {/* Section 1: Oportunidades */}
      <S.Section id="resumo" $variant="1">
        <S.ContentWrapper>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaLightbulb />
              SEÇÃO 1
            </S.SectionBadge>
            <S.SectionTitle>
              <FaChartLine />
              Oportunidades e Vantagens Estratégicas
            </S.SectionTitle>
            <S.SectionSubtitle>
              A Reforma Tributária exige adaptação estratégica. Empresas que se
              anteciparem terão vantagem competitiva, evitarão riscos fiscais e
              poderão otimizar operações dentro do novo sistema CBS/IBS.
            </S.SectionSubtitle>
          </S.SectionHeader>

          <S.HighlightsBox>
            <S.HighlightsTitle>
              <FaRocket />
              Oportunidades de Otimização Estratégica
            </S.HighlightsTitle>
            <S.HighlightsGrid>
              <S.HighlightItem>
                <S.HighlightIcon>
                  <FaSearchDollar />
                </S.HighlightIcon>
                <S.HighlightText>
                  <strong>Identificação de Impactos Reais:</strong> Análise
                  precisa de como CBS/IBS afetará suas operações específicas
                </S.HighlightText>
              </S.HighlightItem>
              <S.HighlightItem>
                <S.HighlightIcon>
                  <FaSyncAlt />
                </S.HighlightIcon>
                <S.HighlightText>
                  <strong>Aproveitamento de Créditos:</strong> Maximização de
                  créditos tributários com não-cumulatividade ampla
                </S.HighlightText>
              </S.HighlightItem>
              <S.HighlightItem>
                <S.HighlightIcon>
                  <FaBalanceScale />
                </S.HighlightIcon>
                <S.HighlightText>
                  <strong>Neutralidade no Resultado:</strong> Ajuste estratégico
                  de precificação para manter margem de lucro
                </S.HighlightText>
              </S.HighlightItem>
              <S.HighlightItem>
                <S.HighlightIcon>
                  <FaFileInvoiceDollar />
                </S.HighlightIcon>
                <S.HighlightText>
                  <strong>Simplificação Operacional:</strong> Redução
                  significativa no tempo de apuração com sistema unificado
                </S.HighlightText>
              </S.HighlightItem>
            </S.HighlightsGrid>
          </S.HighlightsBox>

          <S.SummaryCardsGrid>
            <S.SummaryCard>
              <S.SummaryCardIcon>
                <FaCalendarCheck />
              </S.SummaryCardIcon>
              <S.SummaryCardTitle>Prazo Total</S.SummaryCardTitle>
              <S.SummaryCardValue>16 sem</S.SummaryCardValue>
              <S.SummaryCardDescription>4 meses de implementação</S.SummaryCardDescription>
            </S.SummaryCard>
            <S.SummaryCard>
              <S.SummaryCardIcon>
                <FaTasks />
              </S.SummaryCardIcon>
              <S.SummaryCardTitle>Blocos</S.SummaryCardTitle>
              <S.SummaryCardValue>5</S.SummaryCardValue>
              <S.SummaryCardDescription>Metodologia estruturada</S.SummaryCardDescription>
            </S.SummaryCard>
            <S.SummaryCard>
              <S.SummaryCardIcon>
                <FaHourglassHalf />
              </S.SummaryCardIcon>
              <S.SummaryCardTitle>Total Horas</S.SummaryCardTitle>
              <S.SummaryCardValue>250h</S.SummaryCardValue>
              <S.SummaryCardDescription>Dedicação especializada</S.SummaryCardDescription>
            </S.SummaryCard>
            <S.SummaryCard>
              <S.SummaryCardIcon>
                <FaChartLine />
              </S.SummaryCardIcon>
              <S.SummaryCardTitle>ROI Esperado</S.SummaryCardTitle>
              <S.SummaryCardValue>Alto</S.SummaryCardValue>
              <S.SummaryCardDescription>Otimização tributária</S.SummaryCardDescription>
            </S.SummaryCard>
          </S.SummaryCardsGrid>
        </S.ContentWrapper>
      </S.Section>

      {/* Section 2: Metodologia - 5 Blocos */}
      <S.Section id="metodologia" $variant="2">
        <S.ContentWrapper>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaCogs />
              SEÇÃO 2
            </S.SectionBadge>
            <S.SectionTitle>
              <FaLayerGroup />
              Metodologia em 5 Blocos Estratégicos
            </S.SectionTitle>
            <S.SectionSubtitle>
              Abordagem estruturada e progressiva para implementação completa da Reforma Tributária
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Bloco 1 */}
          <S.BlocoCard>
            <S.BlocoHeader>
              <S.BlocoNumber>1</S.BlocoNumber>
              <S.BlocoInfo>
                <S.BlocoTitle>Diagnóstico Inicial e Mapeamento</S.BlocoTitle>
                <S.BlocoMeta>
                  <S.BlocoMetaItem>
                    <FaClock />
                    Duração: <strong>4 semanas</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoMetaItem>
                    <FaHourglassHalf />
                    Horas: <strong>60h</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoInvestimento>
                    <FaDollarSign />
                    <strong>R$ 18.000,00</strong>
                  </S.BlocoInvestimento>
                </S.BlocoMeta>
              </S.BlocoInfo>
            </S.BlocoHeader>
            <S.BlocoContent>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaBullseye />
                  Objetivos
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Levantamento completo da estrutura tributária atual
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Mapeamento de operações e fluxos fiscais
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Identificação de pontos críticos de impacto
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaClipboardList />
                  Entregas
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Relatório de Diagnóstico Tributário
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Mapa de Operações e Fluxos
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Matriz de Riscos e Oportunidades
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
            </S.BlocoContent>
          </S.BlocoCard>

          {/* Bloco 2 */}
          <S.BlocoCard>
            <S.BlocoHeader>
              <S.BlocoNumber>2</S.BlocoNumber>
              <S.BlocoInfo>
                <S.BlocoTitle>Análise de Impactos CBS/IBS</S.BlocoTitle>
                <S.BlocoMeta>
                  <S.BlocoMetaItem>
                    <FaClock />
                    Duração: <strong>3 semanas</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoMetaItem>
                    <FaHourglassHalf />
                    Horas: <strong>50h</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoInvestimento>
                    <FaDollarSign />
                    <strong>R$ 15.000,00</strong>
                  </S.BlocoInvestimento>
                </S.BlocoMeta>
              </S.BlocoInfo>
            </S.BlocoHeader>
            <S.BlocoContent>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaBullseye />
                  Objetivos
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Simulação de cenários com CBS/IBS
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Cálculo de impactos financeiros
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Análise de aproveitamento de créditos
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaClipboardList />
                  Entregas
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Relatório de Impactos Financeiros
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Simulações de Cenários
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Plano de Aproveitamento de Créditos
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
            </S.BlocoContent>
          </S.BlocoCard>

          {/* Bloco 3 */}
          <S.BlocoCard>
            <S.BlocoHeader>
              <S.BlocoNumber>3</S.BlocoNumber>
              <S.BlocoInfo>
                <S.BlocoTitle>Planejamento Estratégico</S.BlocoTitle>
                <S.BlocoMeta>
                  <S.BlocoMetaItem>
                    <FaClock />
                    Duração: <strong>3 semanas</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoMetaItem>
                    <FaHourglassHalf />
                    Horas: <strong>45h</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoInvestimento>
                    <FaDollarSign />
                    <strong>R$ 13.500,00</strong>
                  </S.BlocoInvestimento>
                </S.BlocoMeta>
              </S.BlocoInfo>
            </S.BlocoHeader>
            <S.BlocoContent>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaBullseye />
                  Objetivos
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Desenvolvimento de estratégias de transição
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Definição de ajustes operacionais
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Planejamento de precificação
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaClipboardList />
                  Entregas
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Plano Estratégico de Transição
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Manual de Ajustes Operacionais
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Estratégia de Precificação
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
            </S.BlocoContent>
          </S.BlocoCard>

          {/* Bloco 4 */}
          <S.BlocoCard>
            <S.BlocoHeader>
              <S.BlocoNumber>4</S.BlocoNumber>
              <S.BlocoInfo>
                <S.BlocoTitle>Implementação e Adequação</S.BlocoTitle>
                <S.BlocoMeta>
                  <S.BlocoMetaItem>
                    <FaClock />
                    Duração: <strong>4 semanas</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoMetaItem>
                    <FaHourglassHalf />
                    Horas: <strong>55h</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoInvestimento>
                    <FaDollarSign />
                    <strong>R$ 16.500,00</strong>
                  </S.BlocoInvestimento>
                </S.BlocoMeta>
              </S.BlocoInfo>
            </S.BlocoHeader>
            <S.BlocoContent>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaBullseye />
                  Objetivos
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Implementação de processos adaptados
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Adequação de sistemas e controles
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Treinamento de equipes
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaClipboardList />
                  Entregas
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Processos Implementados
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Sistemas Adequados
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Equipes Treinadas
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
            </S.BlocoContent>
          </S.BlocoCard>

          {/* Bloco 5 */}
          <S.BlocoCard>
            <S.BlocoHeader>
              <S.BlocoNumber>5</S.BlocoNumber>
              <S.BlocoInfo>
                <S.BlocoTitle>Monitoramento e Ajustes</S.BlocoTitle>
                <S.BlocoMeta>
                  <S.BlocoMetaItem>
                    <FaClock />
                    Duração: <strong>2 semanas</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoMetaItem>
                    <FaHourglassHalf />
                    Horas: <strong>40h</strong>
                  </S.BlocoMetaItem>
                  <S.BlocoInvestimento>
                    <FaDollarSign />
                    <strong>R$ 12.000,00</strong>
                  </S.BlocoInvestimento>
                </S.BlocoMeta>
              </S.BlocoInfo>
            </S.BlocoHeader>
            <S.BlocoContent>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaBullseye />
                  Objetivos
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Acompanhamento pós-implementação
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Ajustes finos e correções
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaCheckCircle />
                    Validação de resultados
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
              <S.BlocoSection>
                <S.BlocoSectionTitle>
                  <FaClipboardList />
                  Entregas
                </S.BlocoSectionTitle>
                <S.BlocoList>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Relatório de Monitoramento
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Ajustes Implementados
                  </S.BlocoListItem>
                  <S.BlocoListItem>
                    <FaFileAlt />
                    Relatório Final de Projeto
                  </S.BlocoListItem>
                </S.BlocoList>
              </S.BlocoSection>
            </S.BlocoContent>
          </S.BlocoCard>
        </S.ContentWrapper>
      </S.Section>

      {/* Section 3: Cronograma */}
      <S.Section id="cronograma" $variant="3">
        <S.ContentWrapper>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaCalendarAlt />
              SEÇÃO 3
            </S.SectionBadge>
            <S.SectionTitle>
              <FaClock />
              Cronograma de Implementação
            </S.SectionTitle>
            <S.SectionSubtitle>
              Timeline estruturada de 16 semanas para implementação completa
            </S.SectionSubtitle>
          </S.SectionHeader>

          <S.TimelineHorizontal>
            <S.TimelineStep>
              <S.TimelineStepMarker>
                <S.TimelineStepIcon as={FaSearch} />
                <S.TimelineStepNumber>Fase 1</S.TimelineStepNumber>
              </S.TimelineStepMarker>
              <S.TimelineStepContent>
                <S.TimelineStepTitle>Diagnóstico</S.TimelineStepTitle>
                <S.TimelineStepDuration>
                  <FaClock />
                  4 semanas
                </S.TimelineStepDuration>
                <S.TimelineStepDescription>
                  Mapeamento completo da estrutura atual
                </S.TimelineStepDescription>
              </S.TimelineStepContent>
            </S.TimelineStep>

            <S.TimelineStep>
              <S.TimelineStepMarker>
                <S.TimelineStepIcon as={FaChartBar} />
                <S.TimelineStepNumber>Fase 2</S.TimelineStepNumber>
              </S.TimelineStepMarker>
              <S.TimelineStepContent>
                <S.TimelineStepTitle>Análise</S.TimelineStepTitle>
                <S.TimelineStepDuration>
                  <FaClock />
                  3 semanas
                </S.TimelineStepDuration>
                <S.TimelineStepDescription>
                  Impactos CBS/IBS e simulações
                </S.TimelineStepDescription>
              </S.TimelineStepContent>
            </S.TimelineStep>

            <S.TimelineStep>
              <S.TimelineStepMarker>
                <S.TimelineStepIcon as={FaLightbulb} />
                <S.TimelineStepNumber>Fase 3</S.TimelineStepNumber>
              </S.TimelineStepMarker>
              <S.TimelineStepContent>
                <S.TimelineStepTitle>Planejamento</S.TimelineStepTitle>
                <S.TimelineStepDuration>
                  <FaClock />
                  3 semanas
                </S.TimelineStepDuration>
                <S.TimelineStepDescription>
                  Estratégias de transição
                </S.TimelineStepDescription>
              </S.TimelineStepContent>
            </S.TimelineStep>

            <S.TimelineStep>
              <S.TimelineStepMarker>
                <S.TimelineStepIcon as={FaCogs} />
                <S.TimelineStepNumber>Fase 4</S.TimelineStepNumber>
              </S.TimelineStepMarker>
              <S.TimelineStepContent>
                <S.TimelineStepTitle>Implementação</S.TimelineStepTitle>
                <S.TimelineStepDuration>
                  <FaClock />
                  4 semanas
                </S.TimelineStepDuration>
                <S.TimelineStepDescription>
                  Adequação e treinamento
                </S.TimelineStepDescription>
              </S.TimelineStepContent>
            </S.TimelineStep>

            <S.TimelineStep>
              <S.TimelineStepMarker>
                <S.TimelineStepIcon as={FaCheckCircle} />
                <S.TimelineStepNumber>Fase 5</S.TimelineStepNumber>
              </S.TimelineStepMarker>
              <S.TimelineStepContent>
                <S.TimelineStepTitle>Monitoramento</S.TimelineStepTitle>
                <S.TimelineStepDuration>
                  <FaClock />
                  2 semanas
                </S.TimelineStepDuration>
                <S.TimelineStepDescription>
                  Ajustes e validação
                </S.TimelineStepDescription>
              </S.TimelineStepContent>
            </S.TimelineStep>
          </S.TimelineHorizontal>

          <S.CronogramaSummary>
            <S.CronogramaSummaryTitle>
              <FaCalendarCheck />
              Prazo Total de Implementação
            </S.CronogramaSummaryTitle>
            <S.CronogramaSummaryHighlight>
              <FaClock />
              <span>16 semanas</span>
            </S.CronogramaSummaryHighlight>
            <S.CronogramaSummaryText>
              <FaCircleInfo />
              Equivalente a 4 meses de trabalho estruturado
            </S.CronogramaSummaryText>
          </S.CronogramaSummary>
        </S.ContentWrapper>
      </S.Section>

      {/* Section 4: Investimento */}
      <S.Section id="investimento" $variant="4">
        <S.ContentWrapper>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaDollarSign />
              SEÇÃO 4
            </S.SectionBadge>
            <S.SectionTitle>
              <FaHandHoldingUsd />
              Investimento e Modalidades
            </S.SectionTitle>
            <S.SectionSubtitle>
              Opções flexíveis de pagamento para viabilizar sua transição tributária
            </S.SectionSubtitle>
          </S.SectionHeader>

          <S.InvestimentoHighlight>
            <S.InvestimentoLabel>Investimento Total</S.InvestimentoLabel>
            <S.InvestimentoValor>R$ 75.000,00</S.InvestimentoValor>
            <S.InvestimentoDescricao>
              Implementação completa em 5 blocos estratégicos
            </S.InvestimentoDescricao>
            <S.InvestimentoDetalhes>
              <S.InvestimentoDetalheItem>
                <FaHourglassHalf />
                Total: <strong>250 horas</strong>
              </S.InvestimentoDetalheItem>
              <S.InvestimentoDetalheItem>
                <FaCalculator />
                Valor/hora: <strong>R$ 300,00</strong>
              </S.InvestimentoDetalheItem>
              <S.InvestimentoDetalheItem>
                <FaCalendarAlt />
                Prazo: <strong>16 semanas</strong>
              </S.InvestimentoDetalheItem>
            </S.InvestimentoDetalhes>
          </S.InvestimentoHighlight>

          <S.ModalidadesGrid>
            <S.ModalidadeCard>
              <S.ModalidadeIcon>
                <FaBolt />
              </S.ModalidadeIcon>
              <S.ModalidadeTitulo>À Vista</S.ModalidadeTitulo>
              <S.ModalidadeValor>R$ 67.500,00</S.ModalidadeValor>
              <S.ModalidadeDescricao>
                Desconto de 10% para pagamento único
              </S.ModalidadeDescricao>
              <S.ModalidadeDetalhes>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  Economia de R$ 7.500,00
                </S.ModalidadeDetalheItem>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  Pagamento único
                </S.ModalidadeDetalheItem>
              </S.ModalidadeDetalhes>
            </S.ModalidadeCard>

            <S.ModalidadeCard>
              <S.ModalidadeIcon>
                <FaCalendarCheck />
              </S.ModalidadeIcon>
              <S.ModalidadeTitulo>Parcelado</S.ModalidadeTitulo>
              <S.ModalidadeValor>4x R$ 18.750,00</S.ModalidadeValor>
              <S.ModalidadeDescricao>
                Pagamento mensal sem juros
              </S.ModalidadeDescricao>
              <S.ModalidadeDetalhes>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  4 parcelas mensais
                </S.ModalidadeDetalheItem>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  Sem juros
                </S.ModalidadeDetalheItem>
              </S.ModalidadeDetalhes>
            </S.ModalidadeCard>

            <S.ModalidadeCard>
              <S.ModalidadeIcon>
                <FaLayerGroup />
              </S.ModalidadeIcon>
              <S.ModalidadeTitulo>Por Bloco</S.ModalidadeTitulo>
              <S.ModalidadeValor>5 parcelas</S.ModalidadeValor>
              <S.ModalidadeDescricao>
                Pagamento ao final de cada bloco
              </S.ModalidadeDescricao>
              <S.ModalidadeDetalhes>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  Pagamento por entrega
                </S.ModalidadeDetalheItem>
                <S.ModalidadeDetalheItem>
                  <FaCheck />
                  Flexibilidade máxima
                </S.ModalidadeDetalheItem>
              </S.ModalidadeDetalhes>
            </S.ModalidadeCard>
          </S.ModalidadesGrid>
        </S.ContentWrapper>
      </S.Section>

      {/* Section 5: Contato */}
      <S.Section id="contato" $variant="5">
        <S.ContentWrapper>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaEnvelope />
              CONTATO
            </S.SectionBadge>
            <S.SectionTitle>
              <FaHandshake />
              Próximos Passos
            </S.SectionTitle>
            <S.SectionSubtitle>
              Entre em contato para agendar uma reunião e iniciar sua transição tributária
            </S.SectionSubtitle>
          </S.SectionHeader>

          <S.ContatoInfoBox>
            <S.ContatoInfoTitulo>FH Souza Advogados</S.ContatoInfoTitulo>
            <S.ContatoInfoSubtitulo>
              Especialistas em Direito Tributário e Reforma Fiscal
            </S.ContatoInfoSubtitulo>
            <S.ContatoDetalhes>
              <S.ContatoItem>
                <S.ContatoItemLabel>Telefone</S.ContatoItemLabel>
                <S.ContatoItemValor>
                  <FaPhone />
                  (11) 99999-9999
                </S.ContatoItemValor>
              </S.ContatoItem>
              <S.ContatoItem>
                <S.ContatoItemLabel>E-mail</S.ContatoItemLabel>
                <S.ContatoItemValor>
                  <FaEnvelope />
                  contato@fhsouza.adv.br
                </S.ContatoItemValor>
              </S.ContatoItem>
              <S.ContatoItem>
                <S.ContatoItemLabel>WhatsApp</S.ContatoItemLabel>
                <S.ContatoItemValor>
                  <FaWhatsapp />
                  (11) 99999-9999
                </S.ContatoItemValor>
              </S.ContatoItem>
            </S.ContatoDetalhes>
            <S.ContatoEndereco>
              <S.ContatoEnderecoTitulo>Endereço</S.ContatoEnderecoTitulo>
              <S.ContatoEnderecoTexto>
                Av. Paulista, 1000 - Conjunto 100<br />
                Bela Vista, São Paulo - SP<br />
                CEP: 01310-100
              </S.ContatoEnderecoTexto>
            </S.ContatoEndereco>
          </S.ContatoInfoBox>
        </S.ContentWrapper>
      </S.Section>
    </S.Container>
  );
};

export default ReformaSYL;
